import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, X } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const StickyFloatingCTA = () => {
  const { user, subscription } = useAuth();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const isPremium = subscription?.subscribed;

  const handleStartTrial = () => {
    if (user) {
      navigate('/pricing');
    } else {
      navigate('/auth');
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      
      // Show after scrolling down 100vh (but not for premium users)
      if (scrollPosition > windowHeight && !isDismissed && !isPremium) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isDismissed, isPremium]);

  if (!isVisible || isPremium) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40 animate-slide-up">
      <div className="relative bg-card border border-primary/20 rounded-lg shadow-glow-primary p-4 max-w-sm">
        <button
          onClick={() => setIsDismissed(true)}
          className="absolute -top-2 -right-2 bg-background border border-primary/20 rounded-full p-1 hover:bg-accent transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <div className="inline-flex items-center gap-1 px-3 py-1 bg-gradient-primary rounded-full text-xs font-bold">
              🎁 Free Trial
            </div>
          </div>
          
          <p className="text-sm font-semibold">
            Ready to start trading like a pro?
          </p>

          <Button 
            size="sm"
            className="w-full bg-gradient-primary hover:shadow-glow-primary transition-all duration-300 group"
            onClick={handleStartTrial}
          >
            {user ? "Get Premium — Start Free Trial" : "Sign Up Now"}
            <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StickyFloatingCTA;
